'use strict';

import './style';
import filtersModule from './filters';
import entitiesModule from './entities';
import incidentsModule from './incidents';
import usersModule from './users';
import analyticsModule from './analytics';
import dispatchModule from './dispatch';
import classifyModule from './classify';
import beatsModule from './beats';
import mappyModule from './mappy';
import teamsModule from './teams';
import notifyModule from './notify';
import controllersModule from './controllers';
import mapsModule from './maps';
import componentsModule from './components';
import holidaysModule from './holidays';

import genericModalDirective from './utils/generic-modal';
import genericActionButtonDirective from './utils/generic-action-button';
import copyToClipboardDirective from './utils/copy';
import gqlDirective from './utils/gql';
import eventWatcherDirective from './utils/event-watcher';
import arrayBuilderDirective from './utils/array-builder';

const MODULE_NAME = 'daupler';

var app = angular.module(MODULE_NAME, [
  filtersModule,
  entitiesModule,
  incidentsModule,
  usersModule,
  analyticsModule,
  dispatchModule,
  classifyModule,
  beatsModule,
  mappyModule,
  teamsModule,
  notifyModule,
  controllersModule,
  mapsModule,
  componentsModule,
  holidaysModule,
]);

app.run(function ($rootScope, $window) {
  'ngInject';
  $rootScope.URL_BASE = $window.location.origin;
});
app.directive('genericModalButton', genericModalDirective);
app.directive('genericActionButton', genericActionButtonDirective);
app.directive('copyToClipboard', copyToClipboardDirective);
app.directive('gql', gqlDirective);
app.directive('eventWatcher', eventWatcherDirective);
app.directive('arrayBuilder', arrayBuilderDirective);

export default MODULE_NAME;
